import { createRouter, createWebHistory } from 'vue-router';
import HomeView from './views/HomeView.vue';

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: '/', name: 'home', component: HomeView },
    {
      path: '/previous-design',
      name: 'previous-design',
      component: () => import('./views/PreviousDesignView.vue'),
    },
    // Old SEO and share URLs still open the live app.
    { path: '/:pathMatch(.*)*', redirect: (to) => ({ name: 'home', query: to.query }) },
  ],
  scrollBehavior(_to, _from, savedPosition) {
    return savedPosition ?? { top: 0 };
  },
});
